import styled from 'styled-components';
import { palette } from 'styled-theme';

const TopbarCommunityWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
   
    // height: auto;
    // background-color: white;
    // overflow: auto;
    // //border: 1px solid ${palette('border', 2)};
    // //padding: 20px 20px 20px 15px;
    // margin-bottom : 20px;
    

    .ant-select-selection{
      border : 0px ;
    }

    .communityName{
      font-family: "Kanit";
      font-size: 16px;
      color: #929292;
    }

    .ant-select-arrow{
      top: 30%;
      right: 5px;
    }
    .ant-select-arrow svg {
      font-size: 12px;
      align-items: center;
    }
`
export default TopbarCommunityWrapper;